import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { SupervisorState } from "./supervisorTypes";

export const useSupervisorReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.supervisor);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<SupervisorState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<SupervisorState>;
};
